/* istanbul ignore file */ import { useCallback, useEffect } from 'react';
import { matchRoutes, useLocation } from 'react-router';
import { useHydration } from './useHydration';
import { useDispatch, useSelector } from 'react-redux';
import { createSetInitLoadingAction } from 'actions/actions';
export function useLocationChange(options) {
    const isHydrated = useHydration();
    const location = useLocation();
    const isEmbedded = useSelector((state)=>state.config.isEmbedded);
    const dispatch = useDispatch();
    const { setCurrentView, routes } = options;
    const handleLocationChange = useCallback(()=>{
        const matches = matchRoutes(routes, location.pathname);
        const matchedRoute = matches[matches.length - 1];
        setCurrentView(matchedRoute);
    }, [
        setCurrentView,
        location,
        routes
    ]);
    useEffect(()=>{
        if (!isHydrated) {
            return;
        }
        if (isEmbedded) {
            // Embedded starts in a loading state, therefore client side hydration expects the same state to be met.
            // Loading is disabled once client has been hydrated.
            dispatch(createSetInitLoadingAction({
                initLoading: false
            }));
        }
        handleLocationChange();
    }, [
        location,
        handleLocationChange,
        isHydrated,
        isEmbedded,
        dispatch
    ]);
}
